"use strict";

exports.__esModule = true;
exports.MetricDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _DropdownCheckboxList = require("../../Core/DropdownCheckboxList/DropdownCheckboxList");
var _URLFilterContext = require("../../Core/URLFilter/URLFilterContext");
var _TranslatorContext = require("../../Core/Translator/TranslatorContext");
var _excluded = ["metricItems", "style"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var getListHeight = function getListHeight(clientRect) {
  if (!clientRect) return 290;
  var newHeight = window.visualViewport.height - clientRect.bottom - 165;
  newHeight = newHeight > 30 ? newHeight : 30;
  return newHeight < 290 ? newHeight : 290;
};

// Blueprint's QueryList only narrows the popover list when a predicate is
// supplied; without one the search box inside the dropdown is a no-op.
var itemPredicate = function itemPredicate(query, _ref) {
  var label = _ref.label;
  return (label || "").toLowerCase().includes(query.toLowerCase());
};
var MetricDropdown = exports.MetricDropdown = function MetricDropdown(_ref2) {
  var metricItems = _ref2.metricItems,
    _ref2$style = _ref2.style,
    style = _ref2$style === void 0 ? {} : _ref2$style,
    extra = _objectWithoutPropertiesLoose(_ref2, _excluded);
  var urlFilter = (0, _react.useContext)(_URLFilterContext.URLFilterContext);
  var _useState = (0, _react.useState)(290),
    listHeight = _useState[0],
    setListHeight = _useState[1];
  var _useContext = (0, _react.useContext)(_TranslatorContext.TranslatorContext),
    translate = _useContext.translate;
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: function ref(node) {
      var newHeight = getListHeight(node == null ? void 0 : node.getBoundingClientRect());
      if (newHeight !== listHeight) setListHeight(newHeight);
    }
  }, /*#__PURE__*/_react["default"].createElement(_DropdownCheckboxList.DropdownCheckboxList, _extends({
    getKey: function getKey(_ref3) {
      var id = _ref3.id,
        name = _ref3.name;
      return id || name;
    },
    renderItemLabel: function renderItemLabel(_ref4) {
      var shortLabel = _ref4.shortLabel;
      return shortLabel;
    },
    renderItemText: function renderItemText(_ref5) {
      var label = _ref5.label;
      return label;
    },
    items: metricItems,
    itemPredicate: itemPredicate,
    allPlaceholder: translate("MetricDropdown.allPlaceholder.All", "All"),
    onSelect: function onSelect(selected) {
      urlFilter.setFilter("metrics", selected.length > 0 ? selected.map(function (metric) {
        return metric.name;
      }).join(",") : ",");
    },
    style: Object.assign({
      marginLeft: "10px",
      minWidth: "100px",
      maxWidth: "12vw",
      justifyContent: "space-between"
    }, style),
    minimal: true,
    maxListHeight: listHeight,
    popoverProps: {
      modifiers: {
        preventOverflow: {
          enabled: true
        },
        flip: {
          enabled: true
        }
      },
      position: _core.Position.BOTTOM
    }
  }, extra)));
};